import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { FullCartLightbox } from './FullCartLightbox.js';
import { makeStillNeeded, makeStillNeededFormatted } from './projectUtils.js';
import { a11yKeyPressWrapper } from './a11yUtils.js';
import { getURLParam } from '../../require/adapters/queryParamsAdapter.js';
import { ajaxAddToCartStatus, ajaxAddToCartSubmit } from '../../require/giveWidget/giveWidgetFunctions.js';

/* global readCookie */ // defined in dc/general/cookies.js

let CompleteThisProjectCallout = function ({ hideCompleteProjectCallout, showMatchCallout, project, updateFullyFundingDonationAmount }) {
    if (hideCompleteProjectCallout) {
        return null;
    }

    if (!showMatchCallout || !project.matchingFund) {
        return (
            <div className="match-tooltip">
                <div tabIndex="0" role="link" onClick={updateFullyFundingDonationAmount} onKeyPress={a11yKeyPressWrapper(updateFullyFundingDonationAmount)} className="match-tooltip-cta">
                    <strong className="js-completing-amount">{makeStillNeededFormatted(project)}</strong> - complete this project and be a hero
                </div>
            </div>
        );
    }
    var matchText = 'matched';
    var matchClass = '';
    var matchImpactMultiple = parseInt(project.matchingFund.matchImpactMultiple);
    if (matchImpactMultiple === 1.5) {
        matchClass = 'onepointfive';
    } else if (matchImpactMultiple === 2) {
        matchText = 'doubled';
    } else if (matchImpactMultiple === 3) {
        matchText = 'tripled';
    }
    return (
        <div className={'match-tooltip ' + matchClass }>All donations currently {matchText}!
            <div>
                You can <span tabIndex="0" role="link" onClick={updateFullyFundingDonationAmount} onKeyPress={a11yKeyPressWrapper(updateFullyFundingDonationAmount)} className="match-tooltip-cta">complete this project for <strong>{makeStillNeededFormatted(project)}</strong></span>.
            </div>
            <div className="match-offer-badge">
                <span className="match-offer-badge-content">{project.matchingFund.multipleForDisplay}</span>
            </div>
        </div>
    );
};
CompleteThisProjectCallout.propTypes = {
    hideCompleteProjectCallout: PropTypes.bool.isRequired,
    showMatchCallout: PropTypes.bool.isRequired,
    project: PropTypes.object.isRequired,
    updateFullyFundingDonationAmount: PropTypes.func.isRequired,
};
CompleteThisProjectCallout = React.memo(CompleteThisProjectCallout);

export const GiveWidget = createReactClass({
    propTypes: {
        project: PropTypes.object.isRequired,

        projectId: PropTypes.string.isRequired,
        showGiveWidget: PropTypes.bool.isRequired,
        prepopulatedDonationAmount: PropTypes.number,
        searchURL: PropTypes.string,
        challengeId: PropTypes.string,
        cart: PropTypes.object,
        submitTakesUserDirectlyToCart: PropTypes.bool,
        showPrimaryGiveButton: PropTypes.bool,
        giveWidgetFormId: PropTypes.string,

        // If this is true, include information about match offers when showing
        // the "complete this project" prompt. False by default.
        showMatchCallout: PropTypes.bool,

        // If this is true, don't show any "complete this project" prompt.
        // False by default.
        hideCompleteProjectCallout: PropTypes.bool,

        // If this is present, will render certain conditional contents (like the
        // FullCartLightbox) in this node using a React Portal. This is helpful in use-cases
        // like ProjectCard, where the entire component is a link to the project,
        // but we don't want a lightbox-child to also be a link to the project.
        //
        // Should be a raw HTML element, like what gets returned from a ref.
        // Type is `instanceOf(Element)` because a raw HTML element will fail a
        // PropTypes.node check. Prefix with `window` to prevent error in serverside render.
        //
        // If you *don't* want to use portals, leave this undefined. Don't pass null. (We warn
        // if the portalTarget is null because that *usually* indicates a broken ref.)
        portalTarget: PropTypes.instanceOf(window.Element),
    },

    getDefaultProps: function () {
        return {
            showPrimaryGiveButton: false,
            giveWidgetFormId: 'simpleWidgetForm',
            showMatchCallout: false,
            hideCompleteProjectCallout: false,
        };
    },

    getInitialState() {
        return {
            donationAmount: this.props.prepopulatedDonationAmount ? this.props.prepopulatedDonationAmount : '',
            showFullCartMessage: false,
        };
    },

    setShowFullCartMessage() {
        this.setState({
            showFullCartMessage: true,
        });
    },

    prevent: function (event) {
        event.preventDefault();
    },

    /**
     * If the response says our cart is full, show the full-cart-message.
     * Otherwise, defer to ajaxAddToCartStatus, the preexisting on-AJAX-donate
     * function from giveWidgetFunctions.js.
     * @param data
     */
    onAjaxComplete: function (data) {
        // Keep in sync with addtocart.donation.AjaxResponseType
        if (data && data.reason === 'FULL_CART') {
            this.setShowFullCartMessage(true);
        } else {
            ajaxAddToCartStatus(data);
        }
    },

    submitForm: function (event) {
        // eslint-disable-next-line react/no-find-dom-node
        var frm = ReactDOM.findDOMNode(this).children[0];
        if (!this.props.submitTakesUserDirectlyToCart) {
            if (event) {
                event.preventDefault();
            }

            ajaxAddToCartSubmit(frm, this.onAjaxComplete);
        } else {
            // if user is in empty cart, set "last search URL" value to search
            // URL from which we attempted to populate the suggested projects.
            if (pageName == 'Checkout (View)') {
                frm.referrer.value = location.href + '&empty=true';
                frm.lastSearchURL.value = readCookie('searchTermsURL');
            }
        }
    },

    updateDonationAmount: function (event) {
        this.setState({
            donationAmount: event.target.value,
        });
    },

    isAlreadyAdded: function (projectId, cart) {
        return cart && cart.proposalDonations && cart.proposalDonations.some(
            function (proposalDonation) {
                return proposalDonation.proposal.id == projectId;
            });
    },

    openCart: function (event) {
        event.preventDefault();
        window.open(secureBaseURL + 'donors/givingCart.html', '_blank');
    },

    onGivingWidgetKeyPress: function (e) {
        if (e.which === 13 && this.state.donationAmount == '') {
            this.prevent(e);
        }
    },

    updateFullyFundingDonationAmount: function (event) {
        event.preventDefault();
        this.setState({
            donationAmount: makeStillNeeded(this.props.project),
        }, function () { this.submitForm(); });
    },

    getCompleteThisProjectCallout: function () {
        return (
            <CompleteThisProjectCallout
                hideCompleteProjectCallout={this.props.hideCompleteProjectCallout}
                showMatchCallout={this.props.showMatchCallout}
                project={this.props.project}
                updateFullyFundingDonationAmount={this.updateFullyFundingDonationAmount}
            />
        );
    },

    render: function () {
        var props = this.props;

        if (this.isAlreadyAdded(props.projectId, props.cart)) {
            return (
                <div className="project-card-give-box">
                    <div style={{ float: 'none' }} className="viewCheckout">
                        <span className="checkout-link" onClick={this.openCart} onKeyDown={this.openCart} role="button" tabIndex="0">
                            <span>Check out</span>
                        </span>
                    </div>
                </div>
            );
        }

        if (!props.showGiveWidget) {
            return null;
        }

        var challengeId = props.challengeId;

        if (!challengeId && props.searchURL) {
            challengeId = getURLParam(props.searchURL, 'challengeId');
        }

        // add challenge attribution for EIF / TIU
        if (!challengeId && readCookie('challengeId') == '20636004') {
            challengeId = '20636004';
        }

        var giveButtonClass = (props.showPrimaryGiveButton) ? 'primary' : 'secondary';

        return (
            <div className="project-card-give-box js-project-card-give-box">
                <form className="form-redux" method="get" id={props.giveWidgetFormId} name={props.giveWidgetFormId} action={secureBaseURL + 'donors/givingCart.html'}>
                    <input type="hidden" defaultValue={props.projectId} name="proposalid" />
                    <input type="hidden" defaultValue={challengeId} name="challengeid" />
                    <input type="hidden" defaultValue="" name="referrer" />
                    <input type="hidden" defaultValue="" name="lastSearchURL" />
                    <div className="dollar-amount">
                        <input aria-label="Donation amount" type="number" onClick={this.prevent} id="donationAmount" className="donation-amount js-donation-amount" name="donationAmount" value={this.state.donationAmount} onChange={this.updateDonationAmount} onKeyPress={this.onGivingWidgetKeyPress} autoComplete="off" />
                        <input onClick={this.submitForm} type="submit" className={'button-' + giveButtonClass + ' heap-give-button'} name="submitButton" value="Give" />
                    </div>
                    {this.getCompleteThisProjectCallout()}
                </form>
                <div className="added" id={'added' + props.projectId}></div>
                <FullCartLightbox showFullCartMessage={this.state.showFullCartMessage} setShowFullCartMessage={this.setShowFullCartMessage} portalTarget={this.props.portalTarget} />
            </div>
        );
    },
});
